import { Link, Tooltip } from '@mui/material';
import { PLAN_STATUS, SEP_PLAN_TAB_LABELS } from '../../shared/AppConstants';
import { PlanStatusBadge } from './PlanStatusBadge';
import { getEnvVar } from '../../utils/getEnvVar';

const convertDate = (date) => {
  if (date) {
    const d = new Date(date);

    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return d.toLocaleDateString('en-GB', options).replace(/ /g, '-');
  } else return '';
};

const planStatusOrder = [
  PLAN_STATUS.SBM_REVIEW,
  PLAN_STATUS.SCI_EDIT,
  PLAN_STATUS.NOT_AVAILABLE, // on the UI this will show as SCI_EDIT
  PLAN_STATUS.REVIEW_COMPLETE
];

const planStatusComparator = (a, b) => {
  const indexA = planStatusOrder.indexOf(a);
  const indexB = planStatusOrder.indexOf(b);

  return indexA - indexB;
};

export const sepPlansColumns = [
  {
    field: 'planNumber',
    headerName: SEP_PLAN_TAB_LABELS.PLAN_ID,
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    renderCell: ({ row }) => {
      const planLabel = row.programNumber + '-' + row.planNumber;
      const planUrl =
        getEnvVar('VITE_SEP_APP_BASE_URL') + '/editPlan/' + planLabel;

      return (
        <Tooltip title={SEP_PLAN_TAB_LABELS.VIEW_OR_EDIT_PLAN_MSG}>
          <Link
            href={planUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="linkExternal"
          >
            {`#${planLabel}`}
          </Link>
        </Tooltip>
      );
    }
  },
  {
    field: 'planStatus',
    headerName: SEP_PLAN_TAB_LABELS.PLAN_STATUS,
    sortComparator: planStatusComparator,
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    renderCell: ({ row }) => <PlanStatusBadge planStatus={row.planStatus} />
  },
  {
    field: 'sciOwner',
    headerName: SEP_PLAN_TAB_LABELS.SCI_BUYER,
    valueGetter: (value, row) => {
      return row.sciBuyerFullName ?? value;
    },
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'planDueDate',
    headerName: SEP_PLAN_TAB_LABELS.PLAN_DUE_DATE,
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    valueFormatter: (value) => {
      return convertDate(value);
    }
  },
  {
    field: 'sopDate',
    headerName: SEP_PLAN_TAB_LABELS.SOP_DATE,
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    valueFormatter: (value) => {
      return convertDate(value);
    }
  },
  {
    field: 'programUnitName',
    headerName: SEP_PLAN_TAB_LABELS.UNIT,
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'programName',
    headerName: SEP_PLAN_TAB_LABELS.SEP_PROGRAM,
    flex: 1.5,
    align: 'left',
    headerAlign: 'left',
    renderCell: ({ row }) => {
      const programNumber = row.programNumber;
      const programLabel = row.programName
        ? `${programNumber} - ${row.programName}`
        : `${programNumber}`;
      const planUrl =
        getEnvVar('VITE_SEP_APP_BASE_URL') + '/viewProgram/' + programNumber;

      return (
        <Tooltip title={SEP_PLAN_TAB_LABELS.VIEW_PROGRAM_MSG}>
          <Link
            href={planUrl}
            target="_blank"
            rel="noopener noreferrer"
            variant="linkExternal"
          >
            {`#${programLabel}`}
          </Link>
        </Tooltip>
      );
    }
  },
  {
    field: 'programStatus',
    headerName: SEP_PLAN_TAB_LABELS.PROGRAM_STATUS,
    flex: 1,
    align: 'left',
    headerAlign: 'left'
  },
  {
    field: 'programPhase',
    headerName: SEP_PLAN_TAB_LABELS.PROGRAM_PHASE,
    flex: 1,
    align: 'left',
    headerAlign: 'left',
    valueFormatter: (value) => {
      return `Phase ${value}`;
    }
  }
];
